import LightModeIcon from "@mui/icons-material/LightMode";
import Logout from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import {
  CircularProgress,
  Divider,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  AvatarMenu as MuiXAvatarMenu,
  AvatarMenuProps as MuiXAvatarMenuProps,
  ThemeModeSwitcher,
} from "common";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { logoutSync } from "features/identity/identitySlice";
import {
  ProfileData,
  selectProfile,
  selectProfileStatus,
} from "features/profile/profileSlice";
import I18n from "i18n-js";
import { Link } from "react-router-dom";

function getMonogram(profile: ProfileData) {
  if (!profile) {
    return null;
  }
  let monogram = profile.first_name[0] ? profile.first_name[0] : "";
  monogram += profile.last_name[0] ? profile.last_name[0] : "";
  return monogram;
}
export interface AavatarMenuProps extends MuiXAvatarMenuProps {}
export default function AvatarMenu({ children, ...props }: AavatarMenuProps) {
  const profile = useAppSelector(selectProfile);
  const profileStatus = useAppSelector(selectProfileStatus);
  const dispatch = useAppDispatch();

  function handleLogout() {
    dispatch(logoutSync());
  }

  return (
    <MuiXAvatarMenu
      avatarProps={{
        sx: {
          backgroundColor: "primary.main",
          color: "white",
          pointerEvents: "auto",
        },
      }}
      avatar={
        profileStatus === "loading" ? (
          <CircularProgress size={20} />
        ) : (
          getMonogram(profile)
        )
      }
      {...props}
    >
      <MenuItem>
        <ListItemIcon>
          <LightModeIcon fontSize="small" />
        </ListItemIcon>
        <ListItemSecondaryAction>
          <ThemeModeSwitcher size="small" />
        </ListItemSecondaryAction>
      </MenuItem>
      {children}
      <Divider />
      <MenuItem onClick={() => handleLogout()}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={I18n.t("App.logout")} />
      </MenuItem>
      <Divider />
      <Typography
        variant="body2"
        align="center"
        sx={{ fontSize: 11, color: "#666666" }}
      >
        {I18n.t("App.version")} {process.env.REACT_APP_VERSION}
      </Typography>
    </MuiXAvatarMenu>
  );
}
